export default __webpack_public_path__ + "hero-lg-3a8830d9c37b4c5f8f01bfb26ee3d3bb.digested.webp";